// Module
var code = `<section class="spyne-pricing" aria-labelledby="pricing-title">
  <div class="spyne-pricing__header">
    <h2 id="pricing-title">Pricing</h2>
    <p class="spyne-pricing__subtitle">Start free. Upgrade when you’re ready to build professionally.</p>
  </div>

  <div class="spyne-pricing__grid">
    <!-- Free -->
    <article class="plan" aria-label="Free plan">
      <header class="plan__header">
        <h3 class="plan__title">Free</h3>
        <p class="plan__tagline">Explore the AppBuilder</p>
      </header>
      <div class="plan__price">
        <span class="plan__amount">\$0</span>
        <span class="plan__period">/mo</span>
      </div>
      <ul class="plan__features">
        <li>AppBuilder (basic)</li>
        <li>CLI (core commands)</li>
        <li>Documentation & examples</li>
        <li><strong>2 app generations</strong> / month</li>
      </ul>
      <footer class="plan__cta">
        <a class="btn btn--ghost" href="/signup">Get started</a>
      </footer>
    </article>

    <!-- Developer (Most popular) -->
    <article class="plan plan--primary" aria-label="Developer plan">
      <div class="plan__badge" aria-hidden="true">Most popular</div>
      <header class="plan__header">
        <h3 class="plan__title">Developer</h3>
        <p class="plan__tagline">Build professionally with CMS & wiring</p>
      </header>
      <div class="plan__price">
        <span class="plan__amount">\$29</span>
        <span class="plan__period">/mo</span>
        <span class="plan__annual">or \$290/yr</span>
      </div>
      <ul class="plan__features">
        <li><strong>CMS plugin</strong></li>
        <li><strong>CLI premium commands</strong></li>
        <li>AppBuilder premium wiring (LocalStorage + Analytics)</li>
        <li>Theme & design-system integration</li>
        <li>Early AI method execution (no codegen)</li>
        <li><strong>25 app generations</strong> / month</li>
      </ul>
      <footer class="plan__cta">
        <a class="btn btn--primary" href="/checkout/developer">Start Developer</a>
      </footer>
    </article>

    <!-- Pro (optional) -->
    <article class="plan" aria-label="Pro plan">
      <header class="plan__header">
        <h3 class="plan__title">Pro</h3>
        <p class="plan__tagline">AI wiring + adapters</p>
      </header>
      <div class="plan__price">
        <span class="plan__amount">\$49</span>
        <span class="plan__period">/mo</span>
        <span class="plan__annual">or \$490/yr</span>
      </div>
      <ul class="plan__features">
        <li>Everything in Developer</li>
        <li><strong>AI codegen with wiring</strong> (ViewStream, Channel, Trait)</li>
        <li>CMS data adapters (Contentful, WP, MongoDB)</li>
        <li>Private plugin publishing</li>
        <li><strong>100 app generations</strong> / month</li>
      </ul>
      <footer class="plan__cta">
        <a class="btn btn--ghost" href="/checkout/pro">Upgrade to Pro</a>
      </footer>
    </article>

    <!-- Enterprise -->
    <article class="plan plan--outline" aria-label="Enterprise plan">
      <header class="plan__header">
        <h3 class="plan__title">Enterprise</h3>
        <p class="plan__tagline">Teams, SSO, and on-prem</p>
      </header>
      <div class="plan__price">
        <span class="plan__amount">\$199+</span>
        <span class="plan__period">/mo</span>
        <span class="plan__annual">custom annual</span>
      </div>
      <ul class="plan__features">
        <li>Everything in Pro</li>
        <li>SSO / Auth0 integration</li>
        <li>Role-based CMS & publishing</li>
        <li>On-prem / private registry options</li>
        <li>Custom AI fine-tuning & support</li>
        <li><strong>Unlimited app generations</strong></li>
      </ul>
      <footer class="plan__cta">
        <a class="btn btn--outline" href="/contact">Contact sales</a>
      </footer>
    </article>
  </div>

  <p class="spyne-pricing__fineprint">
    Need more generations? Add-ons available at checkout. Prices in USD.
  </p>
</section>
`;
// Exports
module.exports = code;